/** @module Apparel/PriceList/ChangeFreezeStatus */
define([
    "dojo/_base/declare",
    "csi/access/crews",
    "csi/def/Action",
    "csi/xml"
], function(declare,crews,Action,xml) {

    return declare(Action, {
        
        /**
         * Provide access to an action even when node is frozen
         * @param {Context} ctx
         */
        hasAccess: function(ctx) {
            if (!crews.isInRoles(["Price List Config Administrator", "Price List Administrator", "Price List Editor"], ctx.getContextNode()))
                return false;
            
            // work around: temporary change the right on the action to read, so that the action will be enabled on the frozen node
            this.m_right = xml.RIGHT_READ;
            this.m_rightParent = xml.RIGHT_READ;
            
            const result = this.inherited(arguments);
            
            this.m_right = xml.RIGHT_WRITE;
            this.m_rightParent = xml.RIGHT_WRITE;
            
            return result;
        }
    
    });
});